import { mapActions, mapGetters } from 'vuex'

export const MIXIN_USER_LIST = {
  computed: {
    ...mapGetters('handbook/user', {
      userList: 'userList'
    })
  },
  async mounted () {
    await this.GETUserList({})
  },
  methods: {
    ...mapActions('handbook/user', {
      GETUserList: 'GETUserList'
    })
  }
}
